import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { AppleDeviceProfileEntry, AppleDeviceProfileType } from './apple-device-profile.types';

export type AppleDeviceProfileState = EntityState<AppleDeviceProfileEntry>;

/**
 * Generates the composite ID for an entity.
 * Used by the EntityAdapter to identify entities.
 *
 * Format:
 * - Single-item profiles: `${udid}-${profileType}`
 * - Multi-item profiles: `${udid}-${profileType}-${itemId}`
 */
export function selectId(entry: AppleDeviceProfileEntry): string {
  return createProfileId(entry.udid, entry.profileType, entry.itemId);
}

/**
 * Helper to construct a profile ID for manual lookups (e.g., in selectors).
 * Also used in selectId().
 */
export function createProfileId(udid: string, profileType: AppleDeviceProfileType, itemId?: string): string {
  return itemId ? `${udid}-${profileType}-${itemId}` : `${udid}-${profileType}`;
}

export const adapter: EntityAdapter<AppleDeviceProfileEntry> = createEntityAdapter<AppleDeviceProfileEntry>({
  selectId,
});

export const initialState: AppleDeviceProfileState = adapter.getInitialState();
